import {
  Component, OnInit, OnDestroy, inject, signal, NgZone, computed, effect, untracked,
  ViewChild, ElementRef, AfterViewChecked, ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ErpAgentService } from './erp-agent.service';
import { ChatService } from '../chat/chat.service';

// ── Speech API types ─────────────────────────────────────────────────────────
declare const webkitSpeechRecognition: any;
declare const SpeechRecognition: any;
type SpeechRecognitionInstance = any;

const TOOL_LABELS: Record<string, string> = {
  // Lectura
  buscar_contactos:               'Buscando contactos…',
  obtener_campanas:               'Consultando campañas…',
  obtener_estadisticas:           'Calculando estadísticas…',
  obtener_listas:                 'Cargando listas…',
  obtener_plantillas:             'Cargando plantillas…',
  obtener_tickets:                'Consultando tickets…',
  buscar_socios_negocio:          'Buscando clientes/proveedores…',
  obtener_oportunidades:          'Consultando oportunidades CRM…',
  obtener_pedidos:                'Consultando pedidos…',
  obtener_cotizaciones:           'Consultando cotizaciones…',
  buscar_productos:               'Buscando productos…',
  obtener_stock:                  'Consultando stock…',
  buscar_proveedores:             'Buscando proveedores…',
  obtener_ordenes_compra:         'Consultando órdenes de compra…',
  obtener_resumen_financiero:     'Calculando resumen financiero…',
  obtener_cuentas_cobrar_pagar:   'Consultando cuentas…',
  buscar_empleados:               'Buscando empleados…',
  obtener_modulos_erp:            'Consultando módulos del sistema…',
  // Salud
  buscar_pacientes:               'Buscando pacientes…',
  obtener_citas_salud:            'Consultando citas médicas…',
  obtener_expediente_paciente:    'Cargando expediente clínico…',
  // Contabilidad
  obtener_cuentas_contables:      'Consultando catálogo contable…',
  obtener_polizas:                'Consultando pólizas…',
  obtener_balance_comprobacion:   'Generando balance de comprobación…',
  // Finanzas avanzadas
  obtener_cuentas_bancarias:      'Consultando cuentas bancarias…',
  obtener_movimientos_bancarios:  'Consultando movimientos bancarios…',
  obtener_cxc_avanzado:           'Consultando cuentas por cobrar…',
  obtener_cxp_avanzado:           'Consultando cuentas por pagar…',
  // Nómina
  obtener_corridas_nomina:        'Consultando corridas de nómina…',
  buscar_empleados_nomina:        'Buscando empleados en nómina…',
  obtener_detalle_nomina:         'Consultando detalle de nómina…',
  // Condominios
  buscar_unidades_condo:          'Buscando unidades de condominio…',
  obtener_adeudos_condo:          'Consultando adeudos…',
  // Contratos
  obtener_contratos:              'Consultando contratos…',
  // Estacionamiento
  obtener_sesiones_parking:       'Consultando sesiones de estacionamiento…',
  obtener_disponibilidad_parking: 'Consultando disponibilidad de espacios…',
  // Construcción
  buscar_proyectos_construccion:  'Buscando proyectos de construcción…',
  obtener_avance_proyecto:        'Consultando avance del proyecto…',
  // Inmobiliaria
  buscar_desarrollos:             'Buscando desarrollos inmobiliarios…',
  buscar_unidades_inmobiliaria:   'Buscando unidades…',
  obtener_ventas_inmobiliaria:    'Consultando contratos de venta…',
  // Manufactura
  obtener_bom:                    'Consultando lista de materiales…',
  obtener_ordenes_produccion:     'Consultando órdenes de producción…',
  // Mantenimiento
  obtener_activos_mantenimiento:  'Consultando activos de mantenimiento…',
  obtener_ordenes_mantenimiento:  'Consultando órdenes de mantenimiento…',
  // Activos Fijos
  obtener_activos_fijos:          'Consultando activos fijos…',
  obtener_depreciaciones:         'Consultando depreciaciones…',
  // Cadena de Suministro
  obtener_transportistas:         'Consultando transportistas…',
  obtener_embarques:              'Consultando embarques…',
  // Calidad
  obtener_inspecciones:           'Consultando inspecciones de calidad…',
  obtener_acciones_correctivas:   'Consultando acciones correctivas…',
  // POS
  obtener_ventas_pos:             'Consultando ventas POS…',
  obtener_turnos_pos:             'Consultando turnos…',
  // E-commerce
  obtener_pedidos_ecommerce:      'Consultando pedidos e-commerce…',
  obtener_canales_ecommerce:      'Consultando canales de venta…',
  // IMSS
  obtener_trabajadores_imss:      'Consultando trabajadores IMSS…',
  obtener_movimientos_imss:       'Consultando movimientos IMSS…',
  // Postventa
  obtener_tickets_postventa:      'Consultando tickets de postventa…',
  obtener_garantias_postventa:    'Consultando garantías…',
  // Accesos
  obtener_log_accesos:            'Consultando registro de accesos…',
  buscar_personas_acceso:         'Buscando personas en accesos…',
  // Escritura
  crear_contacto:                 'Creando contacto…',
  actualizar_contacto:            'Actualizando contacto…',
  crear_socio_negocio:            'Creando socio de negocio…',
  actualizar_socio_negocio:       'Actualizando socio de negocio…',
  crear_oportunidad:              'Creando oportunidad CRM…',
  actualizar_oportunidad:         'Actualizando oportunidad CRM…',
  actualizar_estatus_pedido:      'Actualizando estatus del pedido…',
  actualizar_estatus_cotizacion:  'Actualizando estatus de cotización…',
  actualizar_producto:            'Actualizando producto…',
  actualizar_estatus_orden_compra:'Actualizando orden de compra…',
  crear_ticket:                   'Creando ticket de soporte…',
  actualizar_ticket:              'Actualizando ticket…',
  registrar_ingreso:              'Registrando ingreso…',
  registrar_egreso:               'Registrando egreso…',
  actualizar_empleado:            'Actualizando empleado…',
  // Salud (escritura)
  crear_paciente:                 'Creando paciente…',
  actualizar_paciente:            'Actualizando paciente…',
  crear_cita_salud:               'Agendando cita médica…',
  actualizar_cita_salud:          'Actualizando cita…',
  registrar_movimiento_bancario:  'Registrando movimiento bancario…',
  registrar_pago_condo:           'Registrando pago de condominio…',
  actualizar_estatus_contrato:    'Actualizando contrato…',
  actualizar_avance_proyecto:     'Actualizando avance del proyecto…',
  actualizar_estatus_unidad:      'Actualizando unidad inmobiliaria…',
  crear_orden_produccion:         'Creando orden de producción…',
  actualizar_estatus_orden_produccion: 'Actualizando orden de producción…',
  crear_orden_mantenimiento:      'Creando orden de mantenimiento…',
  actualizar_orden_mantenimiento: 'Actualizando orden de mantenimiento…',
  actualizar_estatus_embarque:    'Actualizando embarque…',
  crear_accion_correctiva:        'Creando acción correctiva…',
  actualizar_accion_correctiva:   'Actualizando acción correctiva…',
  actualizar_estatus_pedido_ecommerce: 'Actualizando pedido e-commerce…',
  registrar_movimiento_imss:      'Registrando movimiento IMSS…',
  crear_ticket_postventa:         'Creando ticket de postventa…',
  actualizar_ticket_postventa:    'Actualizando ticket de postventa…',
};

const TOOL_ICONS: Record<string, string> = {
  // Lectura
  buscar_contactos:               '👤',
  obtener_campanas:               '📧',
  obtener_estadisticas:           '📊',
  obtener_listas:                 '📋',
  obtener_plantillas:             '📄',
  obtener_tickets:                '🎫',
  buscar_socios_negocio:          '🏢',
  obtener_oportunidades:          '🎯',
  obtener_pedidos:                '🛒',
  obtener_cotizaciones:           '📝',
  buscar_productos:               '📦',
  obtener_stock:                  '🏭',
  buscar_proveedores:             '🚚',
  obtener_ordenes_compra:         '🧾',
  obtener_resumen_financiero:     '💰',
  obtener_cuentas_cobrar_pagar:   '💳',
  buscar_empleados:               '👥',
  obtener_modulos_erp:            '🔧',
  // Salud
  buscar_pacientes:               '🏥',
  obtener_citas_salud:            '📅',
  obtener_expediente_paciente:    '📋',
  // Contabilidad
  obtener_cuentas_contables:      '📊',
  obtener_polizas:                '🗒️',
  obtener_balance_comprobacion:   '⚖️',
  // Finanzas avanzadas
  obtener_cuentas_bancarias:      '🏦',
  obtener_movimientos_bancarios:  '💸',
  obtener_cxc_avanzado:           '📥',
  obtener_cxp_avanzado:           '📤',
  // Nómina
  obtener_corridas_nomina:        '💼',
  buscar_empleados_nomina:        '👤',
  obtener_detalle_nomina:         '📃',
  // Condominios
  buscar_unidades_condo:          '🏘️',
  obtener_adeudos_condo:          '💳',
  // Contratos
  obtener_contratos:              '📄',
  // Estacionamiento
  obtener_sesiones_parking:       '🚗',
  obtener_disponibilidad_parking: '🅿️',
  // Construcción
  buscar_proyectos_construccion:  '🏗️',
  obtener_avance_proyecto:        '📈',
  // Inmobiliaria
  buscar_desarrollos:             '🏘️',
  buscar_unidades_inmobiliaria:   '🏠',
  obtener_ventas_inmobiliaria:    '📑',
  // Manufactura
  obtener_bom:                    '🔩',
  obtener_ordenes_produccion:     '🏭',
  // Mantenimiento
  obtener_activos_mantenimiento:  '🔧',
  obtener_ordenes_mantenimiento:  '🛠️',
  // Activos Fijos
  obtener_activos_fijos:          '🏢',
  obtener_depreciaciones:         '📉',
  // Cadena de Suministro
  obtener_transportistas:         '🚛',
  obtener_embarques:              '📦',
  // Calidad
  obtener_inspecciones:           '✅',
  obtener_acciones_correctivas:   '🔄',
  // POS
  obtener_ventas_pos:             '🛍️',
  obtener_turnos_pos:             '🕐',
  // E-commerce
  obtener_pedidos_ecommerce:      '🌐',
  obtener_canales_ecommerce:      '📡',
  // IMSS
  obtener_trabajadores_imss:      '🏥',
  obtener_movimientos_imss:       '📋',
  // Postventa
  obtener_tickets_postventa:      '🔄',
  obtener_garantias_postventa:    '🛡️',
  // Accesos
  obtener_log_accesos:            '🚪',
  buscar_personas_acceso:         '👤',
  // Escritura (nuevos)
  crear_paciente:                 '➕',
  actualizar_paciente:            '✏️',
  crear_cita_salud:               '📅',
  actualizar_cita_salud:          '✏️',
  registrar_movimiento_bancario:  '💸',
  registrar_pago_condo:           '💚',
  actualizar_estatus_contrato:    '📄',
  actualizar_avance_proyecto:     '📈',
  actualizar_estatus_unidad:      '🏠',
  crear_orden_produccion:         '➕',
  actualizar_estatus_orden_produccion: '🏭',
  crear_orden_mantenimiento:      '➕',
  actualizar_orden_mantenimiento: '🛠️',
  actualizar_estatus_embarque:    '🚛',
  crear_accion_correctiva:        '➕',
  actualizar_accion_correctiva:   '✅',
  actualizar_estatus_pedido_ecommerce: '🌐',
  registrar_movimiento_imss:      '🏥',
  crear_ticket_postventa:         '➕',
  actualizar_ticket_postventa:    '✏️',
  // Escritura (existentes)
  crear_contacto:                 '➕',
  actualizar_contacto:            '✏️',
  crear_socio_negocio:            '🏢',
  actualizar_socio_negocio:       '✏️',
  crear_oportunidad:              '🎯',
  actualizar_oportunidad:         '✏️',
  actualizar_estatus_pedido:      '🛒',
  actualizar_estatus_cotizacion:  '📝',
  actualizar_producto:            '📦',
  actualizar_estatus_orden_compra:'🧾',
  crear_ticket:                   '🎫',
  actualizar_ticket:              '✏️',
  registrar_ingreso:              '💚',
  registrar_egreso:               '🔴',
  actualizar_empleado:            '👤',
};

const SUGGESTIONS = [
  'Dame un resumen general del ERP',
  'Muéstrame los pedidos de venta recientes',
  'Busca el producto "laptop" en inventario',
  '¿Cuánto llevamos de ingresos este mes?',
  'Lista las oportunidades CRM abiertas',
];

@Component({
  selector: 'erp-agent-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    /* ── FAB ───────────────────────────────────────────────── */
    .fab {
      position: fixed; bottom: 90px; right: 24px; z-index: 1000;
      width: 46px; height: 46px; border-radius: 50%;
      background: linear-gradient(135deg, #6366f1, #8b5cf6);
      border: none; color: white; cursor: pointer; font-size: 20px;
      display: flex; align-items: center; justify-content: center;
      box-shadow: 0 3px 14px rgba(99,102,241,.45);
      transition: transform .2s ease, box-shadow .2s ease;
    }
    .fab:hover { transform: scale(1.1); box-shadow: 0 5px 22px rgba(99,102,241,.6); }
    .fab.is-open { background: linear-gradient(135deg, #475569, #334155); box-shadow: 0 3px 12px rgba(0,0,0,.3); }

    .fab-tooltip {
      position: fixed; bottom: 144px; right: 20px; z-index: 1000;
      background: #1e293b; color: white; font-size: 11px; font-weight: 600;
      padding: 5px 10px; border-radius: 7px; white-space: nowrap;
      pointer-events: none; box-shadow: 0 2px 8px rgba(0,0,0,.25);
    }
    .fab-tooltip::after {
      content: ''; position: absolute; top: 100%; right: 14px;
      border: 5px solid transparent; border-top-color: #1e293b;
    }

    /* ── Backdrop ───────────────────────────────────────────── */
    .backdrop {
      position: fixed; inset: 0; z-index: 1001;
      background: rgba(15,23,42,.4); backdrop-filter: blur(2px);
      animation: fade-in .2s ease;
    }
    @keyframes fade-in { from{opacity:0} to{opacity:1} }

    /* ── Panel ──────────────────────────────────────────────── */
    .panel {
      position: fixed; top: 0; right: 0; bottom: 0; z-index: 1002;
      width: min(460px, 100vw); display: flex; flex-direction: column;
      background: #f8fafc;
      box-shadow: -8px 0 48px rgba(0,0,0,.22);
      animation: slide-in .28s cubic-bezier(.4,0,.2,1);
    }
    @keyframes slide-in { from{transform:translateX(100%)} to{transform:translateX(0)} }

    /* ── Header ─────────────────────────────────────────────── */
    .header {
      display: flex; align-items: center; gap: 8px;
      padding: 11px 14px; background: #1e293b; color: white;
      flex-shrink: 0; border-bottom: 2px solid #334155;
    }
    .header-icon {
      width: 34px; height: 34px; flex-shrink: 0;
      background: linear-gradient(135deg,#6366f1,#8b5cf6);
      border-radius: 9px; display: flex; align-items: center;
      justify-content: center; font-size: 17px;
    }
    .header-title { font-size: 14px; font-weight: 700; }
    .header-sub   { font-size: 10px; color: #94a3b8; }
    .spacer       { flex: 1; }

    .status-dot    { width: 6px; height: 6px; border-radius: 50%; background: #ef4444; flex-shrink: 0; }
    .status-dot.on { background: #22c55e; animation: pulse-dot 2s infinite; }
    @keyframes pulse-dot { 0%,100%{opacity:1} 50%{opacity:.4} }
    .status-lbl { font-size: 10px; color: #94a3b8; }

    .btn-voice {
      width: 28px; height: 28px; border-radius: 6px; border: 1px solid #475569;
      background: transparent; color: #64748b; cursor: pointer; font-size: 14px;
      display: flex; align-items: center; justify-content: center; flex-shrink: 0;
      transition: all .15s;
    }
    .btn-voice:hover    { background: #334155; color: #94a3b8; }
    .btn-voice.active   { background: #7c3aed; border-color: #7c3aed; color: white; }
    .btn-voice.speaking { background: #059669; border-color: #059669; color: white; animation: wave .8s ease infinite; }
    @keyframes wave { 0%,100%{transform:scale(1)} 50%{transform:scale(1.12)} }

    .voice-select {
      height: 24px; border-radius: 5px; border: 1px solid #475569;
      background: #1e293b; color: #94a3b8; font-size: 10px;
      padding: 0 4px; cursor: pointer; max-width: 120px; outline: none;
      flex-shrink: 0;
    }
    .voice-select:focus { border-color: #7c3aed; color: white; }

    .btn-clear {
      padding: 4px 9px; border-radius: 6px; border: 1px solid #475569;
      background: transparent; color: #94a3b8; cursor: pointer; font-size: 10px;
    }
    .btn-clear:hover { background: #334155; color: white; }
    .btn-close {
      width: 28px; height: 28px; border-radius: 6px; border: 1px solid #475569;
      background: transparent; color: #94a3b8; cursor: pointer; font-size: 13px;
      display: flex; align-items: center; justify-content: center; flex-shrink: 0;
    }
    .btn-close:hover { background: #ef4444; border-color: #ef4444; color: white; }

    /* ── Listening banner ───────────────────────────────────── */
    .listening-bar {
      display: flex; align-items: center; gap: 8px;
      padding: 7px 14px; background: #4f46e5; color: white;
      font-size: 12px; font-weight: 600; flex-shrink: 0;
    }
    .listening-bar .wave { display: flex; gap: 3px; align-items: center; }
    .listening-bar .wave span {
      display: block; width: 3px; background: white; border-radius: 2px;
      animation: bar-bounce .7s ease-in-out infinite alternate;
    }
    .listening-bar .wave span:nth-child(1) { height: 6px;  animation-delay: 0s;   }
    .listening-bar .wave span:nth-child(2) { height: 12px; animation-delay: .1s;  }
    .listening-bar .wave span:nth-child(3) { height: 18px; animation-delay: .2s;  }
    .listening-bar .wave span:nth-child(4) { height: 12px; animation-delay: .3s;  }
    .listening-bar .wave span:nth-child(5) { height: 6px;  animation-delay: .4s;  }
    @keyframes bar-bounce { from{transform:scaleY(.4)} to{transform:scaleY(1)} }
    .interim-text { opacity: .85; font-weight: 400; font-style: italic; flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

    /* ── Messages ───────────────────────────────────────────── */
    .messages-wrap {
      flex: 1; overflow-y: auto; padding: 14px;
      display: flex; flex-direction: column; gap: 10px;
    }
    .welcome {
      display: flex; flex-direction: column; align-items: center;
      padding: 28px 14px; gap: 10px; text-align: center;
    }
    .welcome-icon  { font-size: 38px; }
    .welcome-title { font-size: 17px; font-weight: 700; color: #1e293b; }
    .welcome-sub   { font-size: 12px; color: #64748b; max-width: 340px; line-height: 1.6; }
    .suggestions   { display: flex; flex-wrap: wrap; gap: 6px; justify-content: center; margin-top: 4px; }
    .suggestion {
      padding: 5px 11px; border-radius: 20px; border: 1px solid #e2e8f0;
      background: white; font-size: 12px; color: #475569; cursor: pointer; transition: all .15s;
    }
    .suggestion:hover { background: #6366f1; color: white; border-color: #6366f1; }

    /* Bubbles */
    .msg-row           { display: flex; gap: 8px; }
    .msg-row.user      { flex-direction: row-reverse; }
    .msg-row.assistant { flex-direction: row; }
    .msg-row.tool      { flex-direction: row; opacity: .85; }

    .avatar-chip {
      width: 27px; height: 27px; border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      font-size: 12px; flex-shrink: 0; font-weight: 700;
    }
    .avatar-user      { background: #6366f1; color: white; }
    .avatar-assistant { background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0; }
    .avatar-tool      { background: #fef9c3; color: #92400e; border: 1px solid #fde68a; font-size: 11px; }

    .bubble-wrap { display: flex; flex-direction: column; gap: 2px; max-width: 82%; }
    .msg-row.user .bubble-wrap { align-items: flex-end; }

    .bubble {
      padding: 8px 12px; border-radius: 12px; font-size: 13px;
      line-height: 1.6; word-break: break-word; white-space: pre-wrap;
    }
    .bubble.user      { background: #6366f1; color: white; border-radius: 12px 2px 12px 12px; }
    .bubble.assistant { background: white; color: #1e293b; border: 1px solid #e2e8f0; border-radius: 2px 12px 12px 12px; }
    .bubble.tool {
      background: #fefce8; color: #713f12; border: 1px solid #fde68a;
      border-radius: 8px; font-family: monospace; font-size: 11px;
      max-height: 150px; overflow-y: auto;
    }
    .tool-label {
      font-size: 10px; color: #92400e; font-weight: 600;
      display: flex; align-items: center; gap: 3px; margin-bottom: 3px;
    }
    .msg-time { font-size: 10px; color: #94a3b8; }

    .bubble.assistant.speaking-now {
      border-color: #a5b4fc; box-shadow: 0 0 0 2px rgba(99,102,241,.2);
    }

    /* Thinking */
    .thinking-row { display: flex; align-items: center; gap: 8px; padding: 2px 0; }
    .thinking-bubble {
      display: flex; align-items: center; gap: 6px;
      padding: 8px 12px; background: white; border: 1px solid #e2e8f0;
      border-radius: 2px 12px 12px 12px; font-size: 12px; color: #475569;
    }
    .dots span {
      display: inline-block; width: 5px; height: 5px; border-radius: 50%;
      background: #6366f1; animation: bounce .9s infinite;
    }
    .dots span:nth-child(2) { animation-delay: .2s; }
    .dots span:nth-child(3) { animation-delay: .4s; }
    @keyframes bounce { 0%,80%,100%{transform:translateY(0)} 40%{transform:translateY(-5px)} }

    /* ── Input area ─────────────────────────────────────────── */
    .input-area {
      display: flex; gap: 7px; align-items: flex-end;
      padding: 10px 14px; background: white;
      border-top: 1px solid #e2e8f0; flex-shrink: 0;
    }
    .input-area textarea {
      flex: 1; border: 1.5px solid #e2e8f0; border-radius: 10px;
      padding: 7px 11px; font-size: 13px; resize: none;
      min-height: 36px; max-height: 96px; outline: none;
      font-family: inherit; color: #1e293b; transition: border-color .15s;
      background: #f8fafc;
    }
    .input-area textarea:focus { border-color: #6366f1; background: white; }
    .input-area textarea::placeholder { color: #94a3b8; }

    /* Mic button */
    .btn-mic {
      width: 36px; height: 36px; border-radius: 10px; flex-shrink: 0;
      border: 1.5px solid #e2e8f0; background: #f8fafc;
      color: #64748b; cursor: pointer; font-size: 16px;
      display: flex; align-items: center; justify-content: center;
      transition: all .15s; position: relative;
    }
    .btn-mic:hover:not(:disabled) { border-color: #6366f1; color: #6366f1; background: white; }
    .btn-mic:disabled { opacity: .4; cursor: not-allowed; }
    .btn-mic.listening {
      background: #ef4444; border-color: #ef4444; color: white;
    }
    .btn-mic.listening::before {
      content: ''; position: absolute; inset: -4px; border-radius: 14px;
      border: 2px solid #ef4444; animation: mic-pulse 1.2s ease-out infinite; opacity: .6;
    }
    @keyframes mic-pulse { 0%{transform:scale(1);opacity:.6} 100%{transform:scale(1.5);opacity:0} }

    .btn-send {
      width: 36px; height: 36px; border-radius: 10px; flex-shrink: 0;
      background: linear-gradient(135deg,#6366f1,#8b5cf6);
      border: none; color: white; cursor: pointer; font-size: 15px;
      display: flex; align-items: center; justify-content: center;
      transition: opacity .15s;
    }
    .btn-send:disabled { opacity: .4; cursor: not-allowed; }
    .hint { font-size: 10px; color: #94a3b8; text-align: center; padding: 3px 14px 7px; flex-shrink: 0; }
  `],
  template: `
    <!-- FAB trigger -->
    @if (!chatSvc.panelOpen()) {
      @if (!isOpen()) {
        <div class="fab-tooltip">Agente ERP</div>
      }
      <button
        class="fab"
        [class.is-open]="isOpen()"
        (click)="toggle()"
        [title]="isOpen() ? 'Cerrar agente' : 'Abrir Agente ERP'"
      >{{ isOpen() ? '✕' : '🤖' }}</button>
    }

    @if (isOpen()) {
      <div class="backdrop" (click)="close()"></div>

      <div class="panel">

        <!-- Header -->
        <div class="header">
          <div class="header-icon">🤖</div>
          <div>
            <div class="header-title">Agente ERP</div>
            <div class="header-sub">Código Digital · Asistente Inteligente</div>
          </div>
          <div class="spacer"></div>
          <div class="status-dot" [class.on]="svc.connected()"></div>
          <span class="status-lbl">{{ svc.connected() ? 'Conectado' : 'Sin conexión' }}</span>

          @if (voiceSupported) {
            <button
              class="btn-voice"
              [class.active]="voiceEnabled()"
              [class.speaking]="isSpeaking()"
              (click)="toggleVoice()"
              [title]="voiceEnabled() ? 'Desactivar voz' : 'Activar respuesta por voz'"
            >{{ isSpeaking() ? '🔊' : (voiceEnabled() ? '🔔' : '🔕') }}</button>
            @if (voiceEnabled() && availableVoices().length) {
              <select
                class="voice-select"
                [value]="selectedVoiceName()"
                (change)="setVoice($any($event.target).value)"
                title="Seleccionar voz"
              >
                @for (v of availableVoices(); track v.name) {
                  <option [value]="v.name">{{ v.name }}</option>
                }
              </select>
            }
          }
          @if (hasVisibleMessages()) {
            <button class="btn-clear" (click)="clearChat()">Limpiar</button>
          }
          <button class="btn-close" (click)="close()" title="Cerrar">✕</button>
        </div>

        <!-- Listening banner -->
        @if (isListening()) {
          <div class="listening-bar">
            <div class="wave">
              <span></span><span></span><span></span><span></span><span></span>
            </div>
            <span class="interim-text">{{ interimText() || 'Escuchando…' }}</span>
            <span style="font-size:10px;opacity:.75">Habla ahora</span>
          </div>
        }

        <!-- Messages -->
        <div class="messages-wrap" #scrollEl>

          @if (!hasVisibleMessages()) {
            <div class="welcome">
              <div class="welcome-icon">✨</div>
              <div class="welcome-title">¿En qué te puedo ayudar?</div>
              <div class="welcome-sub">
                Soy tu asistente de ERP. Puedo consultar contactos, campañas,
                pedidos, inventario, finanzas y más.<br>
                Escribe, elige una sugerencia{{ voiceSupported ? ' o habla con el micrófono' : '' }}.
              </div>
              <div class="suggestions">
                @for (s of suggestions; track s) {
                  <button class="suggestion" (click)="send(s)">{{ s }}</button>
                }
              </div>
            </div>
          }

          @for (msg of messages(); track $index) {
            @if (msg.role !== 'tool') {
              <div class="msg-row" [class]="msg.role">
                @if (msg.role === 'user') {
                  <div class="avatar-chip avatar-user">{{ userInitial }}</div>
                } @else {
                  <div class="avatar-chip avatar-assistant">🤖</div>
                }
                <div class="bubble-wrap">
                  <div
                    class="bubble"
                    [class]="msg.role"
                    [class.speaking-now]="msg.role === 'assistant' && $index === speakingIndex()"
                  >{{ msg.content }}</div>
                  <div class="msg-time">{{ msg.timestamp | date:'HH:mm' }}</div>
                </div>
              </div>
            }
          }

          @if (svc.status() === 'thinking') {
            <div class="thinking-row">
              <div class="avatar-chip avatar-assistant">🤖</div>
              <div class="thinking-bubble">
                @if (svc.currentTool()) {
                  {{ toolIcon(svc.currentTool()!) }} {{ toolLabel(svc.currentTool()!) }}
                } @else { Pensando }
                <div class="dots"><span></span><span></span><span></span></div>
              </div>
            </div>
          }

        </div>

        <!-- Input -->
        <div class="input-area">
          <textarea
            [(ngModel)]="inputText"
            [placeholder]="isListening() ? 'Escuchando…' : 'Escribe tu pregunta…'"
            rows="1"
            [disabled]="svc.status() === 'thinking' || isListening()"
            (keydown.enter)="onEnter($event)"
            (input)="autoResize($event)"
          ></textarea>

          @if (voiceSupported) {
            <button
              class="btn-mic"
              [class.listening]="isListening()"
              [disabled]="svc.status() === 'thinking'"
              (click)="toggleListening()"
              [title]="isListening() ? 'Detener grabación' : 'Hablar con el agente'"
            >{{ isListening() ? '⏹' : '🎤' }}</button>
          }

          <button
            class="btn-send"
            [disabled]="!inputText.trim() || svc.status() === 'thinking' || isListening()"
            (click)="send(inputText)"
          >▶</button>
        </div>
        <div class="hint">
          Enter para enviar · Shift+Enter para nueva línea
          @if (voiceSupported) { · 🎤 para hablar }
        </div>

      </div>
    }
  `,
})
export class ErpAgentModalComponent implements OnInit, OnDestroy, AfterViewChecked {
  svc      = inject(ErpAgentService);
  zone     = inject(NgZone);
  cdr      = inject(ChangeDetectorRef);
  chatSvc  = inject(ChatService);

  @ViewChild('scrollEl') private scrollEl!: ElementRef<HTMLElement>;

  readonly messages         = this.svc.messages;
  readonly suggestions      = SUGGESTIONS;
  readonly hasVisibleMessages = computed(() => this.messages().some(m => m.role !== 'tool'));

  isOpen            = signal(false);
  isListening       = signal(false);
  isSpeaking        = signal(false);
  voiceEnabled      = signal(false);
  interimText       = signal('');
  speakingIndex     = signal(-1);
  availableVoices   = signal<SpeechSynthesisVoice[]>([]);
  selectedVoiceName = signal<string>(
    typeof localStorage !== 'undefined' ? (localStorage.getItem('erp-agent-voice') ?? '') : ''
  );
  inputText   = '';
  userInitial = 'U';

  readonly voiceSupported = typeof window !== 'undefined' && (
    'SpeechRecognition' in window || 'webkitSpeechRecognition' in window
  );

  private recognition: SpeechRecognitionInstance = null;
  private shouldScroll    = false;
  private prevMsgCount    = 0;
  private lastSpokenCount = 0;

  private readonly _ttsEffect = effect(() => {
    const msgs  = this.messages();
    const count = msgs.length;
    untracked(() => {
      if (!this.voiceEnabled() || !this.isOpen() || count === 0) return;
      if (count <= this.lastSpokenCount) return;
      this.lastSpokenCount = count;
      const last = msgs[count - 1];
      if (last.role === 'assistant') this.speakMessage(last.content, count - 1);
    });
  });

  async ngOnInit(): Promise<void> {
    await this.svc.connectSocket();
    this.initRecognition();
    this.loadVoices();
  }

  ngOnDestroy(): void {
    this.recognition?.abort();
    window.speechSynthesis?.cancel();
  }

  ngAfterViewChecked(): void {
    const count = this.messages().length;
    if (this.shouldScroll || count !== this.prevMsgCount) {
      this.scrollEl?.nativeElement?.scrollTo({ top: 9e9, behavior: 'smooth' });
      this.shouldScroll = false;
      this.prevMsgCount = count;
    }
  }

  // ── Voice input ────────────────────────────────────────────────────────────

  private initRecognition(): void {
    if (!this.voiceSupported) return;

    const SR = (window as any)['SpeechRecognition'] ?? (window as any)['webkitSpeechRecognition'];
    this.recognition = new SR();
    this.recognition.lang = 'es-MX';
    this.recognition.continuous    = false;
    this.recognition.interimResults = true;
    this.recognition.maxAlternatives = 1;

    this.recognition.onresult = (event: any) => {
      this.zone.run(() => {
        let interim = '';
        let final   = '';
        for (let i = event.resultIndex; i < event.results.length; i++) {
          const t = event.results[i][0].transcript;
          if (event.results[i].isFinal) final += t;
          else interim += t;
        }
        this.interimText.set(interim);
        if (final) {
          this.inputText = final.trim();
          this.cdr.markForCheck();
        }
      });
    };

    this.recognition.onend = () => {
      this.zone.run(() => {
        const text = this.inputText.trim();
        this.isListening.set(false);
        this.interimText.set('');
        if (text) this.send(text);
        this.cdr.markForCheck();
      });
    };

    this.recognition.onerror = (event: any) => {
      this.zone.run(() => {
        this.isListening.set(false);
        this.interimText.set('');
        // 'no-speech' is not an error worth showing
        if (event.error !== 'no-speech') {
          console.warn('SpeechRecognition error:', event.error);
        }
        this.cdr.markForCheck();
      });
    };
  }

  toggleListening(): void {
    if (!this.voiceSupported || !this.recognition) return;
    if (this.isListening()) {
      this.recognition.stop();
    } else {
      window.speechSynthesis?.cancel();
      this.inputText = '';
      this.interimText.set('');
      this.isListening.set(true);
      this.zone.runOutsideAngular(() => this.recognition.start());
    }
  }

  // ── Voice list ─────────────────────────────────────────────────────────────

  private loadVoices(): void {
    if (!('speechSynthesis' in window)) return;
    const populate = () => {
      const all = window.speechSynthesis.getVoices();
      const sorted = [
        ...all.filter(v => v.lang.startsWith('es-MX')),
        ...all.filter(v => v.lang.startsWith('es') && !v.lang.startsWith('es-MX')),
        ...all.filter(v => !v.lang.startsWith('es')),
      ];
      this.zone.run(() => {
        this.availableVoices.set(sorted);
        if (!this.selectedVoiceName() && sorted.length) {
          const def = sorted.find(v => v.lang.startsWith('es-MX'))
                   ?? sorted.find(v => v.lang.startsWith('es'))
                   ?? sorted[0];
          if (def) this.setVoice(def.name);
        }
        this.cdr.markForCheck();
      });
    };
    if (window.speechSynthesis.getVoices().length) populate();
    else window.speechSynthesis.onvoiceschanged = populate;
  }

  setVoice(name: string): void {
    this.selectedVoiceName.set(name);
    if (typeof localStorage !== 'undefined') localStorage.setItem('erp-agent-voice', name);
  }

  // ── Voice output ───────────────────────────────────────────────────────────

  toggleVoice(): void {
    if (this.voiceEnabled()) {
      window.speechSynthesis?.cancel();
      this.isSpeaking.set(false);
      this.speakingIndex.set(-1);
      this.voiceEnabled.set(false);
    } else {
      this.lastSpokenCount = this.messages().length;
      this.voiceEnabled.set(true);
    }
  }

  private speakMessage(text: string, msgIndex: number): void {
    if (!('speechSynthesis' in window)) return;
    window.speechSynthesis.cancel();

    const clean = text
      .replace(/[#*_`~>]/g, '')
      .replace(/\n{2,}/g, '. ')
      .replace(/\n/g, ', ')
      .trim();

    const utt  = new SpeechSynthesisUtterance(clean);
    utt.lang   = 'es-MX';
    utt.rate   = 1.05;
    utt.pitch  = 1.0;
    utt.volume = 1.0;

    const voices = window.speechSynthesis.getVoices();
    const selectedName = this.selectedVoiceName();
    const voice = selectedName
      ? (voices.find(v => v.name === selectedName) ?? voices.find(v => v.lang.startsWith('es-MX')) ?? voices.find(v => v.lang.startsWith('es')))
      : (voices.find(v => v.lang.startsWith('es-MX')) ?? voices.find(v => v.lang.startsWith('es')));
    if (voice) { utt.voice = voice; utt.lang = voice.lang; }

    utt.onstart = () => this.zone.run(() => {
      this.isSpeaking.set(true);
      this.speakingIndex.set(msgIndex);
      this.cdr.markForCheck();
    });
    utt.onend = utt.onerror = () => this.zone.run(() => {
      this.isSpeaking.set(false);
      this.speakingIndex.set(-1);
      this.cdr.markForCheck();
    });

    window.speechSynthesis.speak(utt);
  }

  // ── Panel control ──────────────────────────────────────────────────────────

  toggle(): void {
    this.isOpen.update(v => !v);
  }

  close(): void {
    if (this.isListening()) this.recognition?.stop();
    window.speechSynthesis?.cancel();
    this.isSpeaking.set(false);
    this.speakingIndex.set(-1);
    this.isOpen.set(false);
  }

  // ── Chat ───────────────────────────────────────────────────────────────────

  send(text: string): void {
    if (!text.trim() || this.svc.status() === 'thinking') return;
    this.svc.sendMessage(text.trim());
    this.inputText   = '';
    this.shouldScroll = true;
    this.cdr.markForCheck();
  }

  clearChat(): void {
    if (confirm('¿Limpiar el historial de conversación?')) {
      window.speechSynthesis?.cancel();
      this.isSpeaking.set(false);
      this.speakingIndex.set(-1);
      this.lastSpokenCount = 0;
      this.svc.clearHistory();
    }
  }

  onEnter(ev: Event): void {
    const ke = ev as KeyboardEvent;
    if (!ke.shiftKey) { ev.preventDefault(); this.send(this.inputText); }
  }

  autoResize(ev: Event): void {
    const el = ev.target as HTMLTextAreaElement;
    el.style.height = 'auto';
    el.style.height = Math.min(el.scrollHeight, 96) + 'px';
  }

  toolLabel(tool?: string | null): string {
    return tool ? (TOOL_LABELS[tool] ?? tool) : '';
  }

  toolIcon(tool?: string | null): string {
    return tool ? (TOOL_ICONS[tool] ?? '🔧') : '🔧';
  }
}
